import styled, { css } from 'styled-components';

import { Link as RouterLink } from '@xing-com/crate-core-router';

type RouterLinkProps = React.ComponentProps<typeof RouterLink>;
type RouterLinkState = RouterLinkProps['state'];

export type LinkType = {
  /** path to an internal page withing the router */
  to?: string | null;
  /** URL for an external link outside the router */
  href?: string | null;
  /** open the link in a special browser window? */
  target?: string;
  /** tune links styles */
  originalStyles?: boolean;
  /** state to pass to the router */
  state?: RouterLinkState;
};

export type LinkProps = LinkType & {
  className?: string;
  /** callback function for the onClick attribute of the link */
  onClick?: (event: React.MouseEvent) => void;
};

export const Link: React.FC<React.PropsWithChildren<LinkProps>> = ({
  children,
  to,
  href,
  target,
  originalStyles,
  ...props
}) =>
  to ? (
    <CrateLink $originalStyles={originalStyles} to={to} {...props}>
      {children}
    </CrateLink>
  ) : (
    <NonCrateLink
      $originalStyles={originalStyles}
      {...(href && { href })}
      {...(target && { target })}
      {...(target === '_blank' && { rel: 'noopener noreferrer' })}
      {...props}
    >
      {children}
    </NonCrateLink>
  );

const InheritStyles = css`
  color: inherit;

  &:hover,
  &:focus {
    text-decoration: inherit;
  }
`;

const CrateLink = styled(RouterLink)<{ $originalStyles?: boolean }>`
  ${({ $originalStyles }) => !$originalStyles && `${InheritStyles}`};
`;

const NonCrateLink = styled.a<{ $originalStyles?: boolean }>`
  ${({ $originalStyles }) => !$originalStyles && `${InheritStyles}`};
`;
